/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonInviteReplyInfo,
    JsonInviteReplyInfoFromJSON,
    JsonInviteReplyInfoFromJSONTyped,
    JsonInviteReplyInfoToJSON,
} from './JsonInviteReplyInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonInviteReplyInfo
 */
export interface ApiResultOfJsonInviteReplyInfo {
    /**
     * 
     * @type {JsonInviteReplyInfo}
     * @memberof ApiResultOfJsonInviteReplyInfo
     */
    data?: JsonInviteReplyInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInviteReplyInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonInviteReplyInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInviteReplyInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonInviteReplyInfo
     */
    result?: ApiResultOfJsonInviteReplyInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonInviteReplyInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonInviteReplyInfoFromJSON(json: any): ApiResultOfJsonInviteReplyInfo {
    return ApiResultOfJsonInviteReplyInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonInviteReplyInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonInviteReplyInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonInviteReplyInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonInviteReplyInfoToJSON(value?: ApiResultOfJsonInviteReplyInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonInviteReplyInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

